/* eslint-disable max-statements */
/* eslint-disable no-unused-vars */
/* eslint-disable complexity */
import {Modal, ModalTitle, ModalContent, Box, Typography, Link, ModalContentText} from '@deere/fuel-react';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {show} from '../../redux/features/modal/modal.slice';

export default function ModalPasswords() {
    const modals = useSelector((state) => state.modal.modals);
    const passwordModal = Array.isArray(modals) ? modals.find((m) => m.name === 'passwordModal') : {};
    const [showPassDetails, setShowPassDetails] = useState(false);

    const dispatch = useDispatch();
    const handleClose = (event) => {
        event.preventDefault();
        setShowPassDetails(false);
        dispatch(show({
            name: 'passwordModal',
            display: true
        }));
    };

    const handleMailTo = (event) => {
        event.preventDefault();
        setShowPassDetails(false);
        dispatch(show({
            name: 'passwordModal',
            display: true
        }));
        const template = ['Please fill out following:%0D%0A', 'Name=%0D%0A', 'Caller ID=%0D%0A', 'Phone=%0D%0A', 'Email=%0D%0A', 'Company=%0D%0A', 'Supplier Number=%0D%0A', '%0D%0A', 'Impacted End User Information :%0D%0A', 'Name=%0D%0A', 'Email=%0D%0A', 'User ID=%0D%0A', 'Job Title=%0D%0A', 'Supplier Name=%0D%0A', 'Supplier Number=%20'];

        window.open(`mailto:GlobalITServiceDesk@JohnDeere.com?subject=Password%20Issue&body=${template.join('')}`);
    };

    const openChangePass = () => {
        window.open('https://changepass.johndeere.com/');
    };

    const openForgotPass = () => {
        window.open('https://forgotpass.johndeere.com/');
    };

    const displayPassDetails = () => {
        setShowPassDetails(true);
    };

    const hidePassDetails = () => {
        setShowPassDetails(false);
    };

    return (
        <Modal
            aria-describedby='alert-Modal-description2'
            aria-labelledby='alert-Modal-title2'
            onClose={handleClose}
            open={passwordModal.display}
        >
            <ModalTitle
                divider
                id='alert-Modal-title2'
            >
                {'Passwords Management FAQs'}
            </ModalTitle>

            {!showPassDetails && <ModalContent>
                <Box>
                    <Typography
                        component='p'
                        fontWeight='semibold'
                        gutterBottom
                        size='md'
                    >
                        {'Password Management Tools'}
                    </Typography>

                    <Link
                        href='#'
                        id={1}
                        onClick={(e) => openChangePass(e)}
                    >{'Change Password Tool'}
                    </Link><br/>
                    <Link
                        href='#'
                        id={2}
                        onClick={(e) => openChangePass(e)}
                    >{'Set up PIN to register user id for Forgot your password tool'}
                    </Link><br/>
                    <Link
                        href='#'
                        id={3}
                        onClick={(e) => openForgotPass(e)}
                    >{'Forgot your Password Tool'}
                    </Link>
                </Box>
                <br/>
                <Box>
                    <Typography
                        component='p'
                        fontWeight='semibold'
                        gutterBottom
                        size='md'
                    >
                        {'Password Information and Help'}
                    </Typography>
                    <Link
                        href='#'
                        onClick={displayPassDetails}
                    >{'Does my password expire? If so what do I do?'}</Link>
                </Box>
            </ModalContent>}
            {showPassDetails && <ModalContent>
                <Box>
                    <Link
                        href='#'
                        onClick={hidePassDetails}
                    >{'<< Go Back'}</Link>
                </Box>
                <br/>
                <Box>
                    <Typography
                        component='p'
                        fontWeight='semibold'
                        gutterBottom
                        size='md'
                    >
                        {'Does my password expire?'}
                    </Typography>
                    <ModalContentText>
                        {`Yes. Your password expires every 90 days. You will receive a reminder email 14 days before your password is set to expire. 
                        You may also wish to jot a reminder on your calendar to change your password 2 weeks before it expires.`}
                    </ModalContentText>
                </Box>
                <br/>
                <Box>
                    <Typography
                        component='p'
                        fontWeight='semibold'
                        gutterBottom
                        size='md'
                    >
                        {'What happens if my password does expire?'}
                    </Typography>
                    <Typography
                        component='p'
                        fontWeight='regular'
                        gutterBottom
                        size='md'
                    >
                        {'You can reset your password by utilizing the '}
                        <Link
                            href='#'
                            onClick={openChangePass}
                        >{'Change Password Tool'}</Link>
                        {'.'}
                    </Typography>
                    <Typography
                        component='p'
                        fontWeight='regular'
                        gutterBottom
                        size='md'
                    >
                        {'If you have forgotten the password and set up a PIN, you can update your password at '}
                        <Link
                            href='#'
                            onClick={openForgotPass}
                        >{'https://forgotpass.johndeere.com'}</Link>
                        {'.'}
                    </Typography>
                    <Typography
                        component='p'
                        fontWeight='regular'
                        gutterBottom
                        size='md'
                    >
                        {'If you have forgotten the password and did NOT set up a PIN, you will need to '}
                        <Link
                            href='#'
                            onClick={handleMailTo}
                        >{'contact the Global IT Service Desk '}</Link>
                        {'for a password reset and PIN setup assistance.'}
                    </Typography>
                </Box>
            </ModalContent>}
        </Modal>
    );
}
